import React from 'react'

// Step 1: Define ErrorBoundary component
export default class ErrorBoundary extends React.Component<
  any,
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.error('Error caught by error boundary:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <h1>Something went wrong.</h1>
          <button
            onClick={() => (window.location.href = '/admin-dashboard')}
            type='button'
            style={{
              backgroundColor: 'tomato',
              color: '#fff',
              padding: '10px 15px',
              border: 'none',
              borderRadius: '5px',
              marginBottom: '5px',
            }}
          >
            Try Again
          </button>
        </>
      )
    }

    return this.props.children
  }
}
